import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const PTBoardGamesSetup = () => {
  const [players, setPlayers] = useState([]);
  const [currentPlayer, setCurrentPlayer] = useState("");
  const navigate = useNavigate();

  const addPlayer = () => {
    if (currentPlayer.trim()) {
      setPlayers([...players, currentPlayer]);
      setCurrentPlayer("");
    }
  };

  const startGame = () => {
    if (players.length > 1) {
      navigate("/tonic-ptboardgame", { state: { players } });
    } else {
      alert("Please add at least 2 players.");
    }
  };

  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <h1 className="text-3xl font-bold mb-6 text-yellow-300">Periodic Pursuit</h1>
      <div className="w-96 bg-white p-6 rounded shadow">
        <input
          type="text"
          placeholder="Enter Player Name"
          value={currentPlayer}
          onChange={(e) => setCurrentPlayer(e.target.value)}
          className="w-full p-2 border rounded mb-4"
        />
        <button
          onClick={addPlayer}
          className="bg-blue-500 text-white px-4 py-2 rounded w-full mb-4"
        >
          Add Player
        </button>
        <ul className="list-disc pl-5 mb-4">
          {players.map((player, index) => (
            <li key={index} className="text-gray-700">
              {player}
            </li>
          ))}
        </ul>
        <button
          onClick={startGame}
          className="bg-green-500 text-white px-4 py-2 rounded w-full"
        >
          Start Periodic Pursuit
        </button>
      </div>
    </div>
  );
};

export default PTBoardGamesSetup;
